import { NavLink } from "react-router";
import classNames from "classnames";
import { Division, Flex, Icon, Icons, Paragraph } from "@ir/ui";
import { MASTER_DATA_NAV_CATEGORIES } from "../masterDataNav.config";
import { useMasterDataBrand } from "../MasterDataBrandContext";

export const MasterDataSubNav = () => {
  const { organizationKey, brandKey } = useMasterDataBrand();

  if (!organizationKey || !brandKey) {
    return null;
  }

  const basePath = `/master-data/${organizationKey}/${brandKey}`;

  return (
    <nav className="master-data-subnav" aria-label="Master Data categories">
      {MASTER_DATA_NAV_CATEGORIES.map((category) => (
        <Division key={category.key} className="master-data-subnav__category">
          <Paragraph className="master-data-subnav__category-label m-0">
            {category.label}
          </Paragraph>
          <Division className="master-data-subnav__list">
            {category.items.map((item) => (
              <NavLink
                key={item.key}
                to={`${basePath}/${item.section}`}
                className={({ isActive }) =>
                  classNames("master-data-subnav__item", {
                    "master-data-subnav__item--active": isActive,
                  })
                }
              >
                <Flex
                  align="center"
                  justifyContent="space-between"
                  className="w-100"
                  gap={0.5}
                >
                  <Paragraph className="master-data-subnav__title m-0 text-sm">
                    {item.label}
                  </Paragraph>
                  <Icon
                    name={Icons.ChevronRight}
                    className="master-data-subnav__chevron"
                  />
                </Flex>
              </NavLink>
            ))}
          </Division>
        </Division>
      ))}
    </nav>
  );
};
